import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import { ApplicationState } from "@vp/data-access/application";
import { FormStateProvider } from "@vp/formly/ui-schema-config";
import { of } from "rxjs";

@Injectable()
export class CurrentUserFormStateProviderService implements FormStateProvider {
  constructor(private store: Store) {}

  provide(state: Record<string, unknown>) {
    if (state?.currentUser) {
      const currentUser = this.store.selectSnapshot(ApplicationState.loggedInUser);
      return of({ currentUser });
    }
    return of({});
  }
}
